import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import '../styles/ECatalog.css';

const EProfilePage = () => {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'E‑Profile Download' }]} />
      <div className="ec-page">
        <section className="section">
          <h2>E‑Profile Download</h2>
          <p>
            Download our <strong>company profile</strong> to discover who we are and what we offer. Explore our <strong>solutions</strong> and see how they can <strong>add value</strong> to your projects with <strong>innovative</strong>, <strong>efficient</strong>, and <strong>reliable</strong> systems <strong>tailored to your needs</strong>.
          </p>

          <div className="grid-layout">
            <div className="catalogue-container">
              <div className="catalogue-item">
                <img src={require('../assets/profile_cover.png')} alt="English E-Profile" />
                <p>English E‑Profile</p>
                <a href="" target="_blank" rel="noopener noreferrer" className="download-btn">DOWNLOAD <span className="arrow">⬇</span></a>
              </div>
              <div className="catalogue-item">
                <img src={require('../assets/profile_cover.png')} alt="Arabic E-Profile" />
                <p>Arabic E‑Profile</p>
                <a href="" target="_blank" rel="noopener noreferrer" className="download-btn">DOWNLOAD <span className="arrow">⬇</span></a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EProfilePage;


